module.exports = __webpack_public_path__ + "static/media/Timer_Backing@3x.67be7066.png";